// extracted by mini-css-extract-plugin
export var container = "StockTransferConnection-module--container--+XI58";
export var deleteButton = "StockTransferConnection-module--deleteButton--3d44Z";
export var details = "StockTransferConnection-module--details--cHoto";
export var select = "StockTransferConnection-module--select--+POwm";